import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Privacy from "./sections/Privacy";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Privacy />
    </div>;
}